module.exports = __webpack_public_path__ + "img/ic-list-black.7754b694.svg";